<div
    class="flex flex-column count-card border-round-xl px-3 py-2  border surface-card"
    style="border: 1px solid #e0e0e0; border-radius: 12px"
>
    <div class="flex justify-content-between align-items-center mb-1">
        <div
            class="text-left font-medium text-color-secondary white-space-nowrap title-text"
            style="color: #41414ecc"
        >
            {{ title }}
        </div>
        <div class="font-bold count-text" style="color: #465cb3">
            {{ totalCount ? totalCount : 0 }}
        </div>
    </div>

    <div
        class="w-full mb-3"
        style="
            height: 8px;
            background-color: #e0e0e0;
            border-radius: 4px;
            overflow: hidden;
        "
    >
        <div
            *ngIf="activeProgressPercentage > 0"
            [style.width.%]="activeProgressPercentage"
            [style.backgroundColor]="activeColor"
            style="height: 100%; float: left"
        ></div>
        <div
            *ngIf="upcomingProgressPercentage > 0"
            [style.width.%]="upcomingProgressPercentage"
            [style.backgroundColor]="upcomingColor"
            style="height: 100%; float: left"
        ></div>
        <div
            *ngIf="showSignedOut && signedOutProgressPercentage > 0"
            [style.width.%]="signedOutProgressPercentage"
            [style.backgroundColor]="signedOutColor"
            style="height: 100%; float: left"
        ></div>
        <div
            *ngIf="showNotMarked && notMarkedProgressPercentage > 0"
            [style.width.%]="notMarkedProgressPercentage"
            [style.backgroundColor]="notMarkedColor"
            style="height: 100%; float: left"
        ></div>
        <div
            *ngIf="remainingProgressPercentage > 0"
            [style.width.%]="remainingProgressPercentage"
            [style.backgroundColor]="remainingColor"
            style="height: 100%; float: left"
        ></div>
    </div>

    <div class="labels-grid" style="color: #41414e">
        <span class="flex align-items-center gap-2">
            <i
                class="pi pi-circle-fill"
                style="font-size: 8px"
                [ngStyle]="{ color: activeColor }"
            ></i>
            <span
                class="font-normal"
                (click)="onFilterClick(title, activeLabel)"
                >{{ activeLabel }} ({{ activeCount || 0 }})</span
            >
        </span>
        <span class="flex align-items-center gap-2">
            <i
                class="pi pi-circle-fill"
                style="font-size: 8px"
                [ngStyle]="{ color: upcomingColor }"
            ></i>
            <span
                class="font-normal"
                (click)="onFilterClick(title, upcomingLabel)"
                >{{ upcomingLabel }} ({{ upcomingCount || 0 }})</span
            >
        </span>
        <span *ngIf="showSignedOut" class="flex align-items-center gap-2">
            <i
                class="pi pi-circle-fill"
                style="font-size: 8px"
                [ngStyle]="{ color: signedOutColor }"
            ></i>
            <span
                class="font-normal"
                (click)="onFilterClick(title, signedOutLabel)"
                >{{ signedOutLabel }} ({{ signedOutCount || 0 }})</span
            >
        </span>
        <span *ngIf="showNotMarked" class="flex align-items-center gap-2">
            <i
                class="pi pi-circle-fill"
                style="font-size: 8px"
                [ngStyle]="{ color: notMarkedColor }"
            ></i>
            <span
                class="font-normal"
                (click)="onFilterClick(title, notMarkedLabel)"
                >{{ notMarkedLabel }} ({{ notMarkedCount || 0 }})</span
            >
        </span>
    </div>
</div>
